import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";

import PageAPI from "../../api/PageAPI";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

const useDuplicateView = (pageID: string) => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { tenantID }: any = useParams();

  const duplicateView = useMutation({
    mutationFn: ({
      viewID,
      parentViewID,
    }: {
      viewID: string;
      parentViewID?: string;
      onSuccess?: (newID: string) => void;
    }) => {
      if (parentViewID) {
        return PageAPI.duplicateSubView(
          workspaceID,
          pageID,
          parentViewID,
          viewID
        ).then((data) => ({
          page: null,
          view: data.data.data.view,
          subView: data.data.data.subView,
        }));
      }

      return PageAPI.duplicateView(workspaceID, pageID, viewID).then(
        (data) => ({
          page: data.data.data.page,
          view: data.data.data.view,
          subView: null,
        })
      );
    },
    onSuccess: (result, { onSuccess }) => {
      const { page, view, subView } = result;

      page && queryClient.setQueryData(["page", pageID], page);
      view && queryClient.setQueryData(["view", view._id], view);
      subView && queryClient.setQueryData(["view", subView._id], subView);

      !subView &&
        navigate(
          `/clouds/${tenantID}/workspaces/${workspaceID}/pages/${pageID}/views/${view._id}`
        );

      callFunctionIfExists(onSuccess, subView?._id || view?._id);
    },
  });

  return {
    duplicateView: duplicateView.mutate,
    viewDuplicating: duplicateView.isPending,
  };
};

export default useDuplicateView;
